import $ from 'jquery';

$(() => {
  if ($('.page-about-us').length == 0) {
    return;
  }
});
